export default class ModalLoginPasswordResetMailController {
	/* @ngInject */
	constructor($uibModalInstance, username, delayExpiration, delayUnit) {
		this.$uibModalInstance = $uibModalInstance;
		this.username = username;
		this.delayExpiration = delayExpiration;
		this.delayUnit = delayUnit;
	}

	ok() {
		this.$uibModalInstance.close();
	}
}
